import PropTypes from 'prop-types';
import React from 'react';
import { PREFORMATTED_STRING } from '../../../brands/default/content/components/checkout';

const VipDurationMessage = ({ months }) => {
  if (typeof months !== 'number') return null;
  const isOneYearMessage = months >= 12;
  const monthOrMonths = months === 1 ? 'month' : 'months';

  return (
    <>
      {isOneYearMessage && (
        <>One year of {PREFORMATTED_STRING.brandTerminology.brand} VIP:</>
      )}
      {!isOneYearMessage && (
        <>
          {months} {monthOrMonths} of{' '}
          {PREFORMATTED_STRING.brandTerminology.brand} VIP:
        </>
      )}
    </>
  );
};

VipDurationMessage.propTypes = {
  months: PropTypes.number,
};

export default VipDurationMessage;
